import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { ko } from "vuetify/locale";
import type { ThemeTypes } from "@/common/types/ThemeType";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
// 필요하다면 테마 커스터마이징 옵션 추가
const vuetify = createVuetify({
  components,
  directives,
    locale: {
    locale: "ko",
    fallback: "en",
    messages: { ko },
  },
  theme: {
    defaultTheme: "BLUE_THEME",
    themes: {
      BLUE_THEME: {
        name: "BLUE_THEME",
        dark: false,
        variables: {
          "border-color": "#e5eaef",
          "border-style": "solid",
        },
        colors: {
          primary: "#5D87FF",
          secondary: "#49BEFF",
          info: "#539BFF",
          success: "#13DEB9",
          accent: "#FFAB91",
          warning: "#FFAE1F",
          error: "#FA896B",
          lightprimary: "#ECF2FF",
          lightsecondary: "#E8F7FF",
          lightsuccess: "#E6FFFA",
          lighterror: "#FDEDE8",
          lightinfo: "#EBF3FE",
          lightwarning: "#FEF5E5",
          textPrimary: "#2A3547",
          textSecondary: "#2A3547",
          borderColor: "#e5eaef",
          inputBorder: "#DFE5EF",
          containerBg: "#ffffff",
          background: "#ffffff",
          hoverColor: "#f6f9fc",
          surface: "#fff",
          "on-surface-variant": "#fff",
          grey100: "#F2F6FA",
          grey200: "#EAEFF4",
          white100: "#f6f7f8",
          white200: "#f1f1f1",
          lightblue: "#d9e8f8",
          deepgray: "#898D9C",
          skyblue: "#F4F5FA",
          btnBorderColor: "#CCCED4",
          btnBgColor: "#fff",
          blackColor: "#222",
          bgTransparency: "rgba(255, 255, 255 , 0)",
        },
      } as ThemeTypes,
    },
  },
  defaults: {
    VTextField: {
      variant: "outlined",
      color: "primary",
    },
    VTextarea: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },
    VSelect: {
      variant: "outlined",
      density: "compact",
      color: "primary",
      hideDetails: "true",
    },
    VListItem: {
      minHeight: "45px",
    },
    VTooltip: {
      location: "top",
      activator: "parent",
    },
    VBtn: {
      variant: "outlined",
    },
    VAutocomplete: {
      variant: "outlined",
      density: "compact",
      hideDetails: "true",
      noDataText: "항목이 없습니다.",
    },
    VCombobox: {
      variant: "outlined",
      density: "compact",
      hideDetails: "true",
      bgColor: "default",
    },
    VDivider: {
      class: "border-opacity-100",
    },
    VCheckbox: {
      color: "primary",
      hideDetails: "true",
      density: "compact",
    },
    VRadio: {
      color: "primary",
      hideDetails: "true",
      density: "compact",
    },
    VRadioGroup: {
      color: "primary",
      hideDetails: "true",
    },
    VSnackbar: {
      timeout: "2000",
      location: "top",
      minHeight: "80",
    },
    VTabs: {
      color: "white",
    },
    VSwitch: {
      hideDetails: "true",
      inset: "true",
      class: "toggle_switch",
    },
    VFileInput: {
      density: "compact",
      variant: "outlined",
    },
    VDialog: {
      scrollable: "true",
    },
    VProgressLinear: {
      color: "primary",
    },
  },
});

export default vuetify;
